// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"1c95eedf","777":"8a1eec27"}[chunkId] + ".js";
};